export type AtlasLevel = 1 | 2 | 3;

export function requestedAtlasLevel(screenScale: number): AtlasLevel | null {
  if (!Number.isFinite(screenScale) || screenScale <= 0) return null;
  for (const level of [3, 2, 1] as const) {
    const ratio = screenScale / level;
    if (Math.abs(ratio - Math.round(ratio)) <= 1e-6) return level;
  }
  return ([1, 2, 3] as const).reduce((best, level) => {
    const distance = Math.abs(level - screenScale);
    const bestDistance = Math.abs(best - screenScale);
    return distance < bestDistance || (distance === bestDistance && level > best) ? level : best;
  });
}

export function atlasSamplingFilter(screenScale: number, active: AtlasLevel): 'nearest' | 'linear' {
  if (!Number.isFinite(screenScale) || screenScale <= 0) throw new Error('screen scale must be finite and positive');
  if (![1, 2, 3].includes(active)) throw new Error('active atlas level must be 1, 2, or 3');
  const ratio = screenScale / active;
  return Math.abs(ratio - Math.round(ratio)) <= 1e-6 ? 'nearest' : 'linear';
}

export function atlasDrawScale(screenScale: number, activeLevel: AtlasLevel): number {
  if (!Number.isFinite(screenScale) || screenScale <= 0) throw new Error('screen scale must be finite and positive');
  return screenScale / activeLevel;
}
